module.exports = __webpack_public_path__ + "img/volume.58f67aed.svg";